// applyStyles is a function that takes in two arguments: styles and styleString
export const applyStyles = (styles, styleString) => {
  // Check if element has styles attribute
  styleString = styleString === undefined ? '' : styleString;

  if (!styles) {
    return styleString;
  }

  return Object.entries(styles).reduce((acc, [key, value]) => {
    // For each style, check the key against a list of specific keys
    // If the key matches, add the value directly to the string
    // If the key does not match, add the value with 'px' appended to it
    if (key !== 'fluidContainer') {
      if (
        key === 'text-align' ||
        key === 'color' ||
        key === 'display' ||
        key === 'font-weight' ||
        key === 'background-color' ||
        key === 'width' ||
        key === 'font-style' ||
        key === 'position' ||
        key === 'text-decoration' ||
        key === 'all' ||
        key === 'border' ||
        key === 'fill' ||
        key === 'stroke' ||
        key === 'float' ||
        key === 'z-index' ||
        key === 'text-transform' ||
        key === 'font-family'
      ) {
        return acc + `${key}:${value};`;
      } else if (key === 'content') {
        // we inject this using innerHTML
        return acc;
      } else {
        return acc + `${key}:${value}px;`;
      }
    } else {
      return acc;
    }
  }, styleString);
};

// Adding a new key for font family
